import type { StrategySortOption } from './types';

export const BASE_SORT_GROUP_ID = 'base';

/** Single-chain only: a member's `added_at` is per chain. */
export const DATE_ADDED_SORT_OPTIONS: StrategySortOption[] = [
  {
    key: 'added_at-desc',
    label: 'Date Added (Newest)',
    optionLabel: 'Date Added (Newest)',
    sort: 'added_at',
    order: 'desc',
    sort_metric: null,
  },
  {
    key: 'added_at-asc',
    label: 'Date Added (Oldest)',
    optionLabel: 'Date Added (Oldest)',
    sort: 'added_at',
    order: 'asc',
    sort_metric: null,
  },
];

export const NAME_SORT_OPTIONS: StrategySortOption[] = [
  {
    key: 'name-asc',
    label: 'Name (A-Z)',
    optionLabel: 'Name (A-Z)',
    sort: 'name',
    order: 'asc',
    sort_metric: null,
  },
  {
    key: 'name-desc',
    label: 'Name (Z-A)',
    optionLabel: 'Name (Z-A)',
    sort: 'name',
    order: 'desc',
    sort_metric: null,
  },
];
